import React from 'react';
import { ArrowLeft, Search } from 'lucide-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <main className="flex min-h-screen w-full items-center justify-center overflow-x-hidden bg-slate-950 px-4 py-10 text-white sm:px-6 sm:py-12 lg:px-8">
      <title>Page Not Found | GIGGS</title>
      <div className="w-full max-w-2xl text-center">
        <Link to="/" className="inline-flex no-underline" aria-label="Giggs home">
          <img src="/images/logo-white.png" alt="Giggs" className="h-10 w-auto sm:h-12" />
        </Link>
        <div className="mt-8 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-green-500/10 text-green-400 sm:mt-10 sm:h-16 sm:w-16">
          <Search size={30} />
        </div>
        <p className="mb-0 mt-6 text-sm font-black uppercase tracking-[0.22em] text-green-400">404</p>
        <h1 className="mb-0 mt-3 text-[clamp(2.25rem,7vw,3.5rem)] font-black leading-[1.08] tracking-[-0.03em] text-white">This page is not available</h1>
        <p className="mx-auto mb-0 mt-4 max-w-lg text-sm leading-6 text-slate-400 sm:text-base sm:leading-7">
          The link may be outdated or the page may have moved. Use one of the working Giggs routes below instead.
        </p>
        <div className="mt-7 flex flex-col justify-center gap-3 sm:mt-8 sm:flex-row sm:flex-wrap">
          <Link to="/" className="inline-flex items-center justify-center gap-2 rounded-xl bg-green-600 px-5 py-3 text-sm font-bold text-white no-underline transition hover:-translate-y-0.5 hover:bg-green-500"><ArrowLeft size={17} /> Back to home</Link>
          <Link to="/services" className="rounded-xl border border-white/20 px-5 py-3 text-sm font-bold text-white no-underline transition hover:-translate-y-0.5 hover:bg-white/10">Browse services</Link>
          <Link to="/book" className="rounded-xl border border-white/20 px-5 py-3 text-sm font-bold text-white no-underline transition hover:-translate-y-0.5 hover:bg-white/10">Book a service</Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
